import {
  LOCKED_LIST_FAILED,
  LOCKED_LIST_LOADDATA,
  LOCKED_LIST_LOADING,
  LOCKED_LIST_SUCCESS,
} from "redux/constants/LockedListConst";

const initState = {
  loading: false,
  message: "",
  showMessage: false,
  id: 0,
  data: [],
};

const lockedlistReducer = (state = initState, action) => {
  switch (action.type) {
    case LOCKED_LIST_LOADING:
      return {
        ...state,
        loading: true,
      };
    case LOCKED_LIST_FAILED:
      return {
        ...state,
        message: action.message,
        showMessage: true,
        loading: false,
        stages_loading: false,
      };
    case LOCKED_LIST_SUCCESS:
      return {
        ...state,
        showMessage: false,
        data: action.data,
        loading: false,
      };
    case LOCKED_LIST_LOADDATA:
      return {
        ...state,
        loading: true,
      };

    default:
      return state;
  }
};

export default lockedlistReducer;
